import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

// Collection name
const LEDGER_COLLECTION_BASE = 'pmt2_ledger';

/**
 * Interface for GPO History entry
 */
export interface GpoHistoryEntry {
  date: Date;
  daysAgo: number;
  'Your Name': string;
  'New Value': string;
  note?: string;
  [key: string]: any;
}

/**
 * Fetches GPO History entries from the Gross Profit Override subcollection
 * 
 * @param companyName The company name
 * @param asin The ASIN to fetch GPO history for
 * @returns Array of GPO history entries with days ago calculation
 */
export const getGpoHistory = async (companyName: string, asin: string): Promise<GpoHistoryEntry[]> => {
  try {
    // Reference to the Gross Profit Override document
    const gpoRef = doc(db, LEDGER_COLLECTION_BASE, companyName, asin, 'Gross Profit Override');
    const gpoDoc = await getDoc(gpoRef);
    
    if (!gpoDoc.exists()) {
      return [];
    }
    
    // Get the entries array
    const entries = gpoDoc.data()?.entries || [];
    
    // Calculate days ago for each entry
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set to beginning of day
    
    const processedEntries = entries.map((entry: any) => {
      // Convert Firestore timestamp to Date
      const entryDate = entry.date?.toDate ? entry.date.toDate() : new Date(entry.date.seconds * 1000);
      
      // Calculate days difference
      const diffTime = today.getTime() - entryDate.getTime();
      const daysAgo = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      
      return {
        ...entry,
        daysAgo,
        // Ensure date is a JavaScript Date object
        date: entryDate
      };
    });
    
    // Sort by date (newest first)
    return processedEntries.sort((a: any, b: any) => {
      return b.date.getTime() - a.date.getTime();
    });
  } catch (error) {
    console.error('Error fetching GPO history:', error);
    throw error;
  }
};